type FocusManagerType = {
    trappedFocusEvent: CallableFunction,
    trappedFocusEventWrapper: ((evt: KeyboardEvent) => void) | null,
    $focusableEls: HTMLElement[],
    focusIndex: number,
    trapFocus: CallableFunction,
    untrapFocus: CallableFunction,
};

const FocusManager: FocusManagerType = {
    trappedFocusEvent: () => { return; },
    trappedFocusEventWrapper: null,
    $focusableEls: [],
    focusIndex: 0,

    /**
     * Contraint le focus à l'intérieur d'un ou plusieurs éléments
     * 
     * @param $elements Éléments dans lesquels contraindre le focus
     */
    trapFocus($elements: HTMLElement[]) : typeof self {
        this.untrapFocus();

        $elements.forEach($element => {
            this.$focusableEls = this.$focusableEls.concat(Array.from($element.querySelectorAll('a, button, [tabindex], input')));
        });

        this.trappedFocusEvent = (evt: KeyboardEvent) : void => {
            if (evt.key !== 'Tab') {
                return;
            }

            // Si l'élément focus n'est pas présent dans la liste des éléments focusable,
            // on force le focus sur le premier ou dernier élément en fonction de si on
            // a appuyé sur la touche shift ou pas
            const isContained = $elements.filter($element => $element.contains(document.activeElement)).length > 0;
            if (!isContained) {
                const nextIndex = evt.shiftKey ? this.$focusableEls.length - 1 : 0;
                this.$focusableEls[nextIndex].focus();
            }
        };

        // Stocke la référence stable du wrapper pour pouvoir la retirer avec removeEventListener
        this.trappedFocusEventWrapper = (evt: KeyboardEvent) => this.trappedFocusEvent(evt);
        document.addEventListener('keyup', this.trappedFocusEventWrapper);

        return self;
    },

    /**
     * Supprime la contrainte du focus s'il y en a déjà une
     */
    untrapFocus() : typeof self {
        if (this.trappedFocusEventWrapper) {
            // Utilise la même référence que celle passée à addEventListener pour éviter une fuite mémoire
            document.removeEventListener('keyup', this.trappedFocusEventWrapper);
            this.trappedFocusEventWrapper = null;
            this.trappedFocusEvent = () => { return; };
        }

        this.$focusableEls = [];
        this.focusIndex = 0;

        return self;
    },
};

export default FocusManager;
